export default {
  // 业务工作流
  businessFlow: {
    bussinessFlowInof: 'Business process information',
    flowStatus: 'flow state',
    status: 'state',
    beginTime: 'Launch time',
    creater: 'Founder',
    bussinessFlowPic: 'Business flow chart',
    flowRecord: 'Process record',
    completeTask: 'Completed the task',
    HhaveInHand: 'In-progress',
    yistop: 'Terminated',
    yicompleted: 'Completed',
    yidelete: 'Deleted',
    agreeOrDisagree: 'Agree/disagree',
    businessFlow: 'operation flow',
    businessFlowInfo1: 'Process information',
    approvalPass: 'Approved',
    approvalReject: 'Approval rejection',
    approvaling: 'Under approval',
    approvalResult: 'Approval results',
    taskUpdatePer: 'The person in charge of this task needs to be changed',
    taskAddOrReferenceData: 'This task needs to add or associate data',
    taskAddData: 'This task requires new data',
    agree: 'agree',
    disagree: 'disagree',
    inputContent: 'Fill in comments',
    completedTask: 'Finish the task',
    completeTaskBefore:
      'Before completing this task, you need to select the performer for the next task',
    auth: 'jurisdiction',
    selectPerOverPer: 'The selected person will override the preset executor of the next task',
    selectperAdd: 'The selected person is added to the performer of the next task',
    handlePer: 'Handler',
    selectExecutor: 'Please select the executor',
    changeExecutor: 'Successful replacement of executor',
    selectLeader: 'Please select the person in charge',
    selectNextTaskExecutor: 'Please select the next task executor',
    guanlianDataSUccess: 'Linked data successfully',
    updateLeaderSuccess: 'Successful change of person in charge',
    approvalSuccess: 'Approval completed',
    input: 'fill in',
    updataLeader: 'Person in charge of change',
    resetBussinessflow: 'Reset business process complete',
    stopBussinessflow: 'Termination of business process completion',
    startBussinessflow: 'Restart business process complete',
    changeHandlePer: 'Replacement of executor',
    reset: 'Reset',
    currentVersion: 'current version',
    LatestVedition: 'Latest version',
    stop: 'termination',
    enable: 'Enable',
    temporaryStorage: 'Temporary storage',
    saveAndEnable: 'Save and enable',
    businessNode: 'Business node',
    baseNode: 'Basic node',
    start: 'start',
    flowColor: 'Process color',
    selectColor: 'Choose a color',
    customColor: 'Custom color',
    color: 'color',
    addStage: 'Add phase',
    businessName: 'Business name',
    gouxuan1:
      'If it is checked, the current business activity will be created only after all the branches of the front node are completed',
    gouxuan2: 'If not, there will be multiple processing for subsequent business activities',
    beforeCompleteTask:
      'The current business activity can only be generated after all the front-end nodes are completed',
    describe: 'describe',
    befroreTaskChooseOne: 'Which data in the front-end business activity is operated on',
    executionOperation: 'Perform the operation',
    guanlianModule: 'Association module',
    yunxuAdd: 'Only new data can be created, but existing data cannot be associated',
    oprationContent: 'Operation content',
    oprationBtnName: 'Operation button name',
    approvalBusinessData: 'Approve business data',
    selectApprovaler: 'Select reviewer',
    nodeCompleteNextPer:
      'When the node is completed, the executor can specify the next node executor',
    approvalContent: 'Approval content',
    editFields: 'Edit field',
    addField: 'Add fields',
    businessExecutor: 'Executor of the business',
    approvalCondition: 'approval criteria',
    afterIn: 'After entering',
    stageStopTime: 'Stage dwell time',
    stopTingliu: 'Restricted stay',
    afterChaoshi: 'Post timeout',
    chaoshiRemind: 'Timeout reminder',
    afterRemind: 'Post reminder',
    remindPer: 'Remind people',
    addRemind: 'Add reminder',
    nodeBreanchJudage: 'Node branch judgment',
    condtionIn: 'Qualified entry',
    addBrenchCondition: 'Add branch condition',
    notInCondition: 'Not meeting the above conditions',
    stage: 'stage',
    stageName: 'Stage name',
    proventNodeData: 'Data of the previous node',
    beforeChaoshi: 'Before timeout',
    afterChaoshi1: 'After timeout',
    completeAfter: 'After completion',
    addOrGuanlianData: 'Create or associate module data',
    judge1:
      'Please choose which data in the front-end business activity to perform the operation on',
    judge2: 'The node is missing an incoming line',
    judge3: 'The node does not select the front service data',
    oneStage: 'The first stage',
    businessHuodong: 'Business activities',
    end: 'end',
    di: 'The first',
    dontDelStartNode: 'Cannot delete start node',
    initNodeDontDel: 'Initialization phase cannot be deleted',
    approvalNode: 'Approval node',
    breanchNode: 'Branch node',
    judge4: 'The node has and can only have two connected lines',
    judge5: 'Stage name is required',
    judge6: 'There is at least one business activity node',
    judge7: 'There is at least one end node',
    judge8: 'Cannot be empty',
    judge9: 'Node, must be in phase',
    judge10: 'Node, two identical nodes cannot have more than one connection line',
    judge11: 'The [start] node has and only connected line',
    judge12: 'Node,there is at least one connected out line',
    judge13: 'Node, there is at least one connected in line',
    judge14: '[End] node, at least one connected line',
    judge15: 'Node, with and only one connecting line',
    judge16: 'Node, with and only two connected lines',
    judge17: 'Node, with at least two connected lines',
    judge18: 'There is no direct connection between branch nodes',
    judge19: 'Node name is required',
    judge20: 'Node, which data in the front business activity is not selected for operation',
    judge21: 'Node, association module required',
    judge22: 'Node, select at least one edit field',
    judge23: 'Node, the name of operation button is required',
    judge24: 'Node, business execution is required',
    judge25: 'Node, the approval person is required',
    judge26: 'Node, wrong approval conditions',
    judge27: 'Wrong judgment of node and branch',
    judge28: 'Node, please select the node that does not meet the above conditions',
    currentProcess: 'Current process',
    resetRecord: 'Reset record',
    resetList: 'Reset list',
    processName: 'Process name',
    completionTime: 'Completion time',
    gouxuan3:
      'Ticked post-node does not allow the connection to return the current and previous nodes',
    gouxuan4:
      'The current business activity cannot be generated until all the leading nodes have completed',
    beforBusinessOpertion:
      'Which node in the front-end business activity to perform the operation on',
    moreZhixMemberInfo: 'Multiple executor handling method',
    approval: 'Approval',
    delBusinessFolw: 'Are you sure you want to delete the business process?',
    yingxiangInfo1: 'The current operation will affect',
    yingxiangInfo2: 'Settings will be cleared. Need to reset. Are you sure you want to operate?',
    pleaseChooseOp: 'Select to perform the action',
    qianzhi: 'Front-loading',
    zhixingUp: 'Executive superior',
    newJiedduan: 'new stage',
    judge29:
      'Pre-complete is checked. Post-nodes are not allowed to return current or previous nodes',
    judge30: 'Not allowed to connect to',
    judge31: 'This scenario is not supported at this time',
    judge32:
      'The node is not configured correctly. It is not allowed to connect to other nodes at the end of the connection',
    judge33: 'Incorrect node configuration, please connect correctly',
    judge34: 'Branch misconfiguration, not allowed',
    judge35: 'Connection end and',
    judge36: 'Connecting other business nodes',
    judge37:
      'The branch is not configured correctly. The conditions for connecting end nodes are the same as those for connecting other nodes',

    // 2020-12-28
    submitBusinessForyouHandle: 'The submitted business process needs to be handled by you',
    stageNameCustomComponent: 'Assign the stage name to the custom component',
    customComponentStageName: 'Assign the custom component to the stage name',
    passRemark: 'Approved opinion',
    rejectRemark: 'Reject the opinion',
    viewApprovalData: 'View approval data',
    dataCreatedAwaitingApproval:
      'The data has been created and submitted and is awaiting approval...',
    dataBeenRejectedCreated:
      'Data has been "rejected for approval". Please re-create the data or view the approved data',
    showFillingInstructions: 'The configuration description is displayed in the operation',
    currentModuleHasApprovalFlow:
      'There is an approval process for the current module, and the node is not complete until the approval is passed',
    pendingApprovalUp:
      'If the vacancy is to be approved and replaced, the system automatically fills the vacancy upward',
    emailsSenderPass:
      'The email address of the sender must be authenticated. If the binding is not authenticated, the email will not be sent',
    processAdvice: 'Flow Comment',
    maxLength500: 'Max. 500 characters'
  }
}
